<template>
  <div class="modal-select">
    <Input readonly :value="showName" search :placeholder="`请选择${title}`" @click.native="isShowModal = true" />
    <Modal v-model="isShowModal" transfer scrollable :mask-closable="false" :width="width" :title="`选择${title}`">
      <div>
        <div>
          <Input
            class="search-input"
            placeholder="请输入企业姓名搜索"
            v-model="search.name"
            @on-enter="InquireFrom"
          ></Input>
        </div>
        <div style="margin-top:10px;">
          <Button style="margin-right:10px;" type="primary" class="search-button" @click="InquireFrom">查找</Button>
          <Button class="search-button" @click="resetSearchForm">重置</Button>
        </div>
      </div>
      <template slot="footer">
        <Button type="default" @click="isShowModal = false">取消</Button>
        <Button type="primary" @click="submit">确定</Button>
      </template>
      <TableWithPageBeta
        initData
        ref="TableWithPageBeta"
        style="margin-top:10px;"
        :columns="realColumns"
        :func="func"
        :condition="condition"
      />
    </Modal>
  </div>
</template>
<script>
import TableWithPageBeta from '@/components/Common/TableWithPageBeta'
import { getEnterpriseMgrList, getEnterpriseMgrCount } from '@/api'
const allUser = params => Promise.all([getEnterpriseMgrList(params), getEnterpriseMgrCount(params)])
export default {
  name: 'ModalSelect',
  props: {
    title: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 600
    },
    value: {
      type: [Number, String, Array],
      default: ''
    },
    columns: {
      type: Array,
      default: () => [
        {
          width: 100,
          title: '选择',
          align: 'center',
          render: function(h, { row }) {
            if (this.multi) {
              return h('div', {}, [
                h('Checkbox', {
                  props: {
                    value: this.realValue.includes(row.id)
                  },
                  on: {
                    input: v => {
                      if (v) {
                        this.realValue.push(row.id)
                      } else {
                        let index = this.realValue.findIndex(value => value === row.id)
                        this.realValue.splice(index, 1)
                      }
                      this.getUserName(this.realValue.join(','))
                    }
                  }
                })
              ])
            } else {
              return h('div', {}, [
                h('Checkbox', {
                  props: {
                    value: this.realValue === row.id
                  },
                  on: {
                    input: v => {
                      if (v) {
                        this.realValue = row.id
                        this.showName = row.name
                      } else {
                        this.realValue = ''
                        this.showName = ''
                      }
                    }
                  }
                })
              ])
            }
          }
        },
        {
          title: '名称',
          align: 'center',
          key: 'name'
        },
        {
          title: '行业',
          align: 'center',
          key: 'industry'
        },
        {
          title: 'id',
          align: 'center',
          key: 'id'
        }
      ]
    },
    func: {
      type: Function,
      default: allUser
    },
    searchForm: {
      type: Object,
      default: () => ({})
    },
    multi: {
      type: Boolean,
      default: false
    }
  },
  components: {
    TableWithPageBeta
  },
  data() {
    return {
      isShowModal: false,
      showName: '',
      search: {
        keyword: ''
      }
    }
  },
  watch: {
    value: {
      handler(v) {
        if (!v) {
          this.showName = ''
        } else {
          if (this.multi) {
            this.getUserName(v.join(','))
          } else {
            this.getUserName(v)
          }
        }
      },
      immediate: true
    }
  },
  computed: {
    realColumns() {
      this.columns.forEach(v => {
        if (v.render) {
          v.render = v.render.bind(this)
        }
      })
      return this.columns
    },
    realValue: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    },
    condition() {
      return Object.assign(this.search, this.searchForm)
    }
  },
  methods: {
    submit() {
      this.isShowModal = false
      this.$emit('on-change', this.realValue, this.showName)
    },
    async getUserName(userId) {
      try {
        if (!userId) return (this.showName = '')
        await this.$http.get('/enterprise/mgr/info/' + userId).then(res => {
          if (res.success) {
            this.showName = res.data.name
          }
        })
      } catch (error) {}
    },
    InquireFrom() {
      this.$refs.TableWithPageBeta.init(true)
    },
    resetSearchForm(type) {
      this.search.keyword = ''
      if (type === 1) {
        this.isShowModal = false
      } else {
        this.InquireFrom()
      }
    }
  }
}
</script>
<style lang="less">
.modal-select {
  .auto-complete-item {
    margin: 0;
    line-height: normal;
    padding: 7px 16px;
    clear: both;
    color: #515a6e;
    font-size: 12px !important;
    white-space: nowrap;
    list-style: none;
    cursor: pointer;
    .auto-complete-group span {
      color: #666;
    }
  }
  .search-detail {
    display: flex;
    .search-input {
      width: 260px;
    }
    .search-button {
      margin-left: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ModalSelect.vue